/** P2 체크리스트 섹션별 항목 리스트. */
import { ChecklistItem, ChecklistStatus } from '../../services/checklistApi';

const STATUS_LABEL: Record<ChecklistStatus, string> = {
  pass: 'PASS',
  ready: 'READY',
  warn: 'WARN',
  fail: 'FAIL',
  unknown: 'CHECK',
  manual: 'MANUAL',
  skip: 'SKIP',
};

interface Props {
  items: ChecklistItem[];
}

export default function ChecklistSections({ items }: Props) {
  const grouped: Record<string, ChecklistItem[]> = {};
  items.forEach((it) => {
    if (!grouped[it.section]) grouped[it.section] = [];
    grouped[it.section].push(it);
  });

  return (
    <div className="ck-sections">
      {Object.entries(grouped).map(([section, sectionItems]) => (
        <section key={section} className="ck-section">
          <div className="ck-section-header">
            <h3>{section}</h3>
            <span>{sectionItems.length}개 항목</span>
          </div>
          <div className="ck-item-list">
            {sectionItems.map((it) => (
              <article key={it.key} className={`ck-item ck-row-${it.status}`}>
                <div className="ck-item-main">
                  <span className={`ck-status-pill ck-pill-${it.status}`}>{STATUS_LABEL[it.status]}</span>
                  <strong>{it.label}</strong>
                </div>
                <div className="ck-item-detail">
                  <span className="ck-cell-actual">{it.actual ?? '-'}</span>
                  <span className="ck-cell-note">{it.note ?? '-'}</span>
                </div>
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
